import React, {useState} from "react";
import {Accordion, AccordionDetails, AccordionSummary, FormControlLabel, Grid, Radio, Typography, useTheme} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import {IExtensionManagementForm} from "../../models/models";
import {FormCheckbox, FormDateTimePicker, FormRadioGroup, FormTextField} from "../../common/form-fields-wrappers";

const RecapInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const [accordion, setAccordion] = useState(true);

    const raExtensionForm = useFormContext<IExtensionManagementForm>();

    const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
        e.stopPropagation();

        setAccordion(expanded);
    }

    return (
        <Accordion expanded={accordion} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"h6"}>
                    {t("extensionManagement.recapInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='extensionPeriod'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.extensionPeriod")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormRadioGroup<IExtensionManagementForm>
                            name="renewedByExtension"
                            label={t("extensionManagement.recapInfo.form.label.renewedByExtension")}
                            disabled
                        >
                            <FormControlLabel
                                value="false"
                                label={t("extensionManagement.recapInfo.form.radio.renewedByExtension.no")}
                                control={<Radio />}
                            />
                            <FormControlLabel
                                value="true"
                                label={t("extensionManagement.recapInfo.form.radio.renewedByExtension.yes")}
                                control={<Radio />}
                            />
                        </FormRadioGroup>
                    </Grid>

                    {/*/!* Extended *!/*/}
                    {/*<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>*/}
                    {/*    <FormDateTimePicker<IExtensionManagementForm>*/}
                    {/*        name="extendedDropoffDateTimeAllowed"*/}
                    {/*        control={raExtensionForm.control}*/}
                    {/*        label={t("Extended Drop-Off Date Allowed")}*/}
                    {/*        disabled*/}
                    {/*    />*/}
                    {/*</Grid>*/}

                    {/*<Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>*/}
                    {/*    <FormTextField<IExtensionManagementForm>*/}
                    {/*        name='extensionPeriodAllowed'*/}
                    {/*        control={raExtensionForm.control}*/}
                    {/*        label={t("Extension Period Allowed")}*/}
                    {/*        fullWidth*/}
                    {/*        disabled*/}
                    {/*    />*/}
                    {/*</Grid>*/}

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='creditType'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.creditType")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='lastModifiedBy'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.lastModifiedBy")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormCheckbox<IExtensionManagementForm>
                            name={`reservedPricing`}
                            label={t("extensionManagement.recapInfo.form.label.reservedPricing")}
                            color={'primary'}
                            disabled
                            sx={{color: theme.palette.primary.main}}
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='rentalExtensionAmount'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.rentalExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='ancillariesExtensionAmount'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.ancillariesExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='totalExtensionAmount'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.totalExtensionAmount")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IExtensionManagementForm>
                            name="extensionTimestamp"
                            control={raExtensionForm.control}
                            label={t("extensionManagement.recapInfo.form.label.extensionTimestamp")}
                            disabled
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default RecapInfo;